import React from 'react';
import classNames from 'classnames';
import $ from 'jquery';
import idgen from 'app/lib/idgen';
import constants from 'modules/app/constants/materialize';
import moment from 'moment';


class Input extends React.Component {

    constructor(props) {
        super(props);
        this.state = {value: props.defaultValue || props.value};
        this._onChange = this._onChange.bind(this);
        this.isSelect = this.isSelect.bind(this);
    }

    componentDidMount() {
        if (this.props.type === 'select' && !this.props.browserDefault && typeof $ !== 'undefined') {
            this.initMaterialSelect();
            $(this.refs.inputEl).on('change', this._onChange);
        } else if (this.props.type === 'date' && !this.props.browserDefault && typeof $ !== 'undefined') {
            this.initMaterialDatePicker();
        } /*else if (this.props.type === 'switch' && !this.props.browserDefault && typeof $ !== 'undefined') {
            $(this.refs.inputEl).on('change', this._onChange);
        }*/
    }

    initMaterialSelect() {
        setTimeout(()=>{$(this.refs.inputEl).material_select();}, 0);
    }

    initMaterialDatePicker() {
        let component = this;
        let format = this.props.format || 'DD/MM/YYYY';
        let $inputText = $(this.refs.inputEl);
        let options = this.props.datePickerOptions || {};

        let $inputDate = $(this.refs.datePicker).pickadate({
            selectMonths: options.selectMonths || true, // Creates a dropdown to control month
            selectYears: options.selectYears || 0, // Creates a dropdown of 2 years to control year,
            min: options.min || new Date(/*new Date().getTime() + (24 * 60 * 60 * 1000)*/), // Only allow dates beginning from today
            max: options.max /*|| new Date(new Date().getTime() + ((24 * 60 * 60 * 1000) * 2))*/
        });

        let picker = $inputDate.pickadate('picker');

        let setPickerDateFromInput = function () {
            let parsedDate = moment(this.value, format);

            if (parsedDate.isValid()) {
                picker.set('select', [parsedDate.get('year'), parsedDate.get('month'), parsedDate.get('date')]);
            } else {
                //TODO: Invalid date
            }
        };

        $inputText.on('change', setPickerDateFromInput);

        picker.on('set', function(data)  {
            if (!data.select) {
                return;
            }

            let val = moment(this.get('value')).format(format);
            //$inputText.val(val);
            component._onChange(val);
            picker.close();
        });
    }

    _onChange(e) {
        let value = e.target ? e.target.value : e;

        if (this.props.onChange) {
            this.props.onChange(e);
        }

        this.setState({
            value
        });
    }

    isSelect() {
        return this.props.type === 'select';
    }

    render() {
        let { browserDefault, defaultValue, initialValue, placeholder, id, type, label, wrapperClass,
            children, validate, onChange, labelSwitchOff, labelSwitchOn, help, suffix, touched, error, ...props} = this.props;

        let classes = {
            col: true,
            'input-field': type !== 'checkbox' && type !== 'radio' && type !== 'switch'
        };
        constants.SIZES.forEach(size => {
            if (this.props[size]) {
                classes[size + this.props[size]] = true;
            }
        });
        if (!id) {
            id = `input_${idgen()}`;
        }
        let inputClasses = {
            validate,
            'browser-default': browserDefault
        };

        let Comp, inputType;
        switch (type) {
            case 'textarea':
                Comp = 'textarea';
                inputClasses['materialize-textarea'] = true;
                break;
            case 'switch':
                Comp = 'input';
                inputType = 'checkbox';
                break;
            case 'date':
                Comp = 'input';
                inputClasses['datepicker'] = true;
                inputType = 'text';
                break;
            default:
                Comp = 'input';
                inputType = type || 'text';
        }

        let labelClasses = {
            active: initialValue || this.state.value || this.isSelect() || this.props.placeholder || this.props.value
        };

        let htmlLabel = label ? <label className={classNames(labelClasses)} htmlFor={id} >{label}</label> : null;
        let helpLabel = help ? <div className="input-help">{help}</div> : null;
        let errorLabel = touched && error ? <div className="input-error">{error}</div> : null;

        labelSwitchOff = labelSwitchOff || 'Off';
        labelSwitchOn = labelSwitchOn || 'On';

        if (this.isSelect()) {
            let options = placeholder && !defaultValue ? [<option disabled key={idgen()}>{placeholder}</option>] : [];
            options = options.concat(React.Children.map(children, (child) => {
                return React.cloneElement(child, {'key': child.props.value});
            }));
            this.initMaterialSelect();
            return (
                <div className={classNames(classes)}>
                    {htmlLabel}
                    <select
                        id={id}
                        className={classNames(inputClasses)}
                        onChange={this._onChange}
                        ref="inputEl"
                        value={this.state.value}
                        {...props}
                    >
                        {options}
                    </select>
                </div>
            );
        } else if (type === 'switch') {
            return (
                <div className={classNames(classes,'switch')}>
                    <label>
                        {labelSwitchOff}
                        <input type="checkbox" name={this.props.name} onChange={onChange} {...props} ref="inputEl" />
                        <span className="lever"></span>
                        {labelSwitchOn}
                    </label>
                </div>
            );
        } else if (type === 'date') {
            //setTimeout(()=>{$(this.refs.inputEl).trigger('change');}, 0);
            return (
                <div className={classNames(classes)}>
                    <i className="material-icons suffix">today</i>
                    <input className="suffix-btn" type="text" ref="datePicker" />
                    <Comp
                        id={id}
                        className={classNames(inputClasses)}
                        onChange={this._onChange}
                        placeholder={placeholder}
                        ref="inputEl"
                        type={inputType}
                        value={this.state.value}
                        autoComplete="off"
                        {...props}
                    />
                    {htmlLabel}
                    {helpLabel}
                </div>
            );

        } else {
            let icon = null;
            if (React.Children.count(children) == 1) {
                icon = React.Children.only(children);
            }

            return (
                <div className={classNames(classes, wrapperClass)}>
                    {icon === null ? null : React.cloneElement(icon, {className: 'prefix'})}
                    {suffix === undefined ? null : <div className="suffix">{suffix}</div>}
                    <Comp
                        id={id}
                        className={classNames(inputClasses)}
                        onChange={this._onChange}
                        placeholder={placeholder}
                        ref="inputEl"
                        type={inputType}
                        value={this.state.value}
                        {...props}
                    />
                    {htmlLabel}
                    {helpLabel}
                    {errorLabel}
                </div>
            );
        }
    }

}

Input.propTypes = {
    s: React.PropTypes.number,
    m: React.PropTypes.number,
    l: React.PropTypes.number,
    label: React.PropTypes.node,
    labelSwitchOn: React.PropTypes.string,
    labelSwitchOff: React.PropTypes.string,
    /**
     * Input field type, e.g. select, checkbox, radio, text, tel, email
     * @default 'text'
     */
    type: React.PropTypes.string,
    defaultValue: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.bool]),
    placeholder: React.PropTypes.string,
    wrapperClass: React.PropTypes.string,
    id: React.PropTypes.string,
    name: React.PropTypes.string,
    validate: React.PropTypes.bool,
    browserDefault: React.PropTypes.bool,
    onChange: React.PropTypes.func,
    children: React.PropTypes.node,
    initialValue: React.PropTypes.node,
    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.bool]),
    help: React.PropTypes.node,
    suffix: React.PropTypes.node,
    format: React.PropTypes.string,
    error: React.PropTypes.node,
    invalid: React.PropTypes.bool,
    touched: React.PropTypes.bool,
    datePickerOptions: React.PropTypes.object
};

Input.defaultProps = {type: 'text', value: ''};

export default Input;
